import type { PayloadAction } from '@reduxjs/toolkit';

export interface AsyncStatus {
  loading: boolean;
  saving: boolean;
  error: string | null;
}

export const initialAsyncStatus: AsyncStatus = {
  loading: false,
  saving: false,
  error: null,
};

/** Reducer helpers for slices that share loading / saving / error fields. */
export const asyncStatusReducers = {
  markSaving<T extends AsyncStatus>(state: T) {
    state.saving = true;
    state.error = null;
  },
  markLoading<T extends AsyncStatus>(state: T) {
    state.loading = true;
    state.error = null;
  },
  resolveLoaded<T extends AsyncStatus>(state: T) {
    state.loading = false;
    state.error = null;
  },
  resolveSaveSucceeded<T extends AsyncStatus>(state: T) {
    state.saving = false;
  },
  resolveFailed<T extends AsyncStatus>(state: T, action: PayloadAction<string>) {
    state.loading = false;
    state.saving = false;
    state.error = action.payload;
  },
};
